import Delivery from "./delivery";
import Customer from "./customer";
import Payment from "./payment";
import Comment from "./comment";
import Summary from "./summary";
import UserConsent from "../../user-consent/vue-user-consent";

import { merge } from "lodash";

import { mapGetters, mapMutations, mapState, mapActions } from "vuex";

export default {
	template: "#checkout",
	data() {
		return {
			userConsentChecked: true,
			isSaving: false
		}
	},
	components: {
        Delivery,
        Customer,
		Payment,
		Comment,
		Summary,
		UserConsent
	},
	computed: {
        ...mapGetters({
			steps: "checkout/steps",
			allStepsAreValid: "checkout/allStepsAreValid",
			firstStepId: "checkout/firstStepId",
			firstDisabledStepIndex: "checkout/firstDisabledStepIndex",
			activeStep: "checkout/activeStep"
		}),
		...mapState({
			isAuthorize: state => state.checkout.isAuthorize,
			loading: state => state.checkout.loading,
			city: state => state.checkout.city,
			state: state => state
		}),
		submitBlockDisabled() {
			return (this.allStepsAreValid) ? false : true;
		},
		submitButtonDisabled() {
			return (!this.submitBlockDisabled) ? false : true;
		},
	},
	methods: {
		...mapActions({
			setData: "checkout/setData",
			refreshOrder: "checkout/refreshOrder"
		}),
		...mapMutations({
			setStepDisabledState: "checkout/setStepDisabledState"
		}),
		enableFirstStep() {
			this.setStepDisabledState({stepId: this.firstStepId, value: false});
		},
		openModal(url) {
			if (window.loadModalByUrl) window.loadModalByUrl(url);
		},
		setUserConsent(val) {
			this.userConsentChecked = val;
		},
		saveOrder() {
			this.isSaving = true;
			this.refreshOrder("saveOrderAjax").then(data => {
				this.isSaving = false;
				window.location.replace(data.redirectUrl);
			});
		},
		getCache() {
			let cached = localStorage.getItem("checkoutAuthCache");
			let cachedObj = null;
			if (cached) {
				try {
					cachedObj = JSON.parse(cached);
				} catch(e) { console.log(e); }
				localStorage.removeItem("checkoutAuthCache");
			}
			return cachedObj;
		},
	},
	watch: {
		loading(val) {
			if (val) {
				document.body.classList.add("is-loading");
			} else {
				document.body.classList.remove("is-loading");
			}
		}
	},
	mounted() {
	},
	created() {
		let cache = this.getCache();
		if (cache) merge(window.arResult, cache);
		this.setData(window.arResult);

		this.enableFirstStep();

		$(document).on("click", "[data-checkout-auth]", (e) => {
			e.preventDefault();
			this.openModal("/include/modals/auth.php");
		});

		$(document).on("auth-success", () => {
			let dataToSave = {
				delivery: this.state.delivery.delivery,
				personType: this.state.customer.personType,
				paySystem: this.state.payment.paySystem,
				props: this.state.checkout.props,
				extra: {
					addingNewProfile: true
				}
			}
			localStorage.setItem("checkoutAuthCache", JSON.stringify(dataToSave));
			window.location.href = "/basket/";
		});
	}
}
